import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Suspense as _Suspense, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8e13080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"1200px","margin":"0 auto 0"} }
const _hoisted_2 = {
  key: 1,
  class: "summer-back-deliver-fee",
  href: "/hub/summerBackDeliverFee"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/activity/expressFee/shopcart_top_banner.png",
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  id: "shopcart",
  class: "pt_20",
  style: {"background":"#F1F3F4"}
}
const _hoisted_6 = {
  class: "viewport",
  style: {"background":"#fff"}
}
const _hoisted_7 = {
  id: "cart",
  class: "s-content rel"
}
const _hoisted_8 = { class: "ft-w-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 0,
  class: "shopcart-stock-jp-banner-tip"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/stock_jp/d2c_stock_icon.png",
  alt: "",
  class: "stock-icon"
}, null, -1))
const _hoisted_13 = { class: "name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1"} }, null, -1))
const _hoisted_15 = {
  class: "btn-icon",
  target: "_blank",
  href: "/ja/stockJpManual"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/stock_jp/warning_icon.png",
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "num" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "商品選択・商品オプション", -1))
const _hoisted_19 = { class: "tag" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/arrow_icon.png",
  alt: ""
}, null, -1))
const _hoisted_21 = {
  key: 5,
  class: "guide-num-line",
  style: {"margin-bottom":"10px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "num" }, "3", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "保管先倉庫", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 6,
  class: "shopcart-stock-warehouse"
}
const _hoisted_26 = { class: "shopcart-stock-warehouse-title" }
const _hoisted_27 = { class: "shopcart-stock-warehouse-form" }
const _hoisted_28 = { class: "flex-ter" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_CN.png",
  alt: "",
  style: {"width":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_30 = { class: "flex-ter" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_JP.png",
  alt: "",
  style: {"width":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_32 = { class: "flex-ter" }
const _hoisted_33 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_CN.png",
  alt: "",
  style: {"width":"24px","margin-right":"4px"}
}
const _hoisted_34 = {
  key: 1,
  src: "https://static-s.theckb.com/BusinessMarket/icon/icon_JP.png",
  alt: "",
  style: {"width":"24px","margin-right":"4px"}
}
const _hoisted_35 = {
  key: 0,
  class: "tip"
}
const _hoisted_36 = {
  key: 0,
  class: "shopcart-stock-warehouse-address"
}
const _hoisted_37 = {
  key: 1,
  class: "shopcart-stock-warehouse-tip-content"
}
const _hoisted_38 = { class: "shopcart-stock-warehouse-tip" }
const _hoisted_39 = { class: "title" }
const _hoisted_40 = { class: "text" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = ["innerHTML"]

import { WarningFilled } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import { ref, computed, watch, onMounted, toRaw, nextTick } from 'vue'
import SwitchDeliver from './components/SwitchDeliver.vue'
import ShopTable from './components/ShopTable.vue'
import FigurePay from './components/FigurePay.vue'
import PriceRate from './components/PriceRate.vue'
import ConfirmOrder from './components/ConfirmOrder.vue'
import ChoiceConfirmOrder from './components/choice/ConfirmOrder.vue'
import Guide from '@/components/guide/index.vue'
import ChoiceShopTable from './components/choice/ShopTable.vue'
import OpenMemberTip from './components/OpenMemberTip.vue'
import OpenMember from './components/OpenMember.vue'
import FreeShipping from '@/views/goods/components/FreeShipping.vue'
import { getRelIngt, searchIsInStoreApi, createOrderPreCheckApi, canUseOnTheWayStockApi, updateShopcartApi, getDeliveryCashbackActivityApi } from '@/apis/shopcart'
import { getIsShowCustomsApi, hasOrderAvailableTransportationNums, pageOrderOnTheWayStockApi, getD2cMoneyApi } from '@/apis/order'
// import { useGlobal } from '@/util/useLoading'
import calcLadder, { flatCart, calcGp, setStock } from '@/util/calcLadder'
import { dayjs, ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useRtfix, isD2C, isKO, isEN, isJA, isMultiStore, isChoiceShop, isShowStockJpBtn } from '@/store'
import UploadFileBtn from './components/UploadFileBtn.vue'
import { arr2map } from '@/plugins/utils'
import NoStockModal from './components/NoStockModal.vue'
import KrCustomsTip from '@/components/common/KrCustomsTip/index.vue'
import CommonTip from '@/components/CommonTip/index.vue'
import ConfirmStockModal from './ConfirmStockModal.vue'
import bus from '@/util/useBus'
import { sourceCountryRef, sourceCountryInfo, tCurrency, stockWarehouse } from './country'
import { COUNTRY } from '@/global'
import NewUserTip from './components/NewUserTip.vue'
import OrderExhausted from './components/OrderExhausted.vue'
import GuidePlat from './components/GuidePlat.vue'
import useChoice from './useChoice'
import CartBcIntro from './components/CartBcIntro.vue'
import CountdownTimer from './CountdownTimer.vue'
import UnRechargeModal from '@/components/UnRechargeModal/index.vue'
import { request } from '@/config/request/interceptors'
import { ShopType } from '@/common/const'
import StockJp from './stockJp/index.vue'
import { CartGroupItemDTO, CartItemDTO } from '@/service/order'
import CreateOrderGuide from './components/CreateOrderGuide.vue'
import FeeVipTip from './components/FreeVipTip.vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { isFirstPayVipApi } from '@/apis/usercenter'
interface Sku {
  onTheWayStockQuantity: number
  checked: boolean
  cartId: number
  productCode: string
  productPriceLadderList: any[]
  orderQuantity: number
  stockQuantity: number
  productType: number
  buyQuantity: number
  price: number
  totalPrice: number
  adtPrice: number
  cartAdditionList: any[]
  combinationProductItemList: any[]
  notInStorage?: number
  productSku?: string
  productStatus?: number
  originalstockQuantity?: number
  consignPrice?: number
  isOnePsale?: boolean
  livePriceFlag?: number
  productSellPrice?: number
  minOrderQuantity?: number
  noPriceLadder?: boolean
}
interface Shop {
  cartList: Sku[]
  productType?: number
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [getConfig, setConfig] = useUserConfig(ENUM_CONFIG_CODE.FREE_VIP_LEVEL_DIALOG)
const [getConfig2, setConfig2] = useUserConfig(ENUM_CONFIG_CODE.HISTORY_VIP_LEVEL_DIALOG)

const isReady = ref(false)
const route = useRoute()
const store = useStore()
const router = useRouter()
const figurePayRef = ref()
const Layout1 = [
  { label: '商品名称', name: 'title', width: 'auto' },
  { label: t('客户商品sku'), name: 'customSku', width: 140 },
  { label: '商品属性', name: 'sku', width: 120 },
  { label: '下单数量', name: 'amount', width: 120 },
  { label: t('单价') + tCurrency('CNY'), name: 'price', width: 110 },
  { label: t('小计') + tCurrency('CNY'), name: 'total', width: 110 },
  { label: '商品附加项', name: 'adt', width: 150 },
  { label: '操作', name: 'run', width: 140 }
].fort()

/** tiktok店铺，非韩国仓 */
const showTiktok = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C() && sourceCountryRef.value !== COUNTRY.KR)
/** 是否日本仓 */
const isJpTitkTokShop = computed(() => showTiktok.value && sourceCountryRef.value === COUNTRY.JP)
// 日本仓非TikTok店铺不展示在途库存，因为日本仓不区分平台
const isJpNoTikTokShop = computed(() => !showTiktok.value && sourceCountryRef.value === COUNTRY.JP)
const shopInfo = computed(() => store.getters.shopInfo)
// 是否解除tiktok限制购买的能力
const isTiktokWhite = ref(false)
const Layout2 = computed(() => {
  let title = '使用库存/采购数量'
  if ((showTiktok.value && !isTiktokWhite.value) || sourceCountryRef.value === COUNTRY.JP) {
    title = `注文利用数/${t(sourceCountryRef.value === COUNTRY.JP ? '日本仓' : '中国仓')}${t('总在库数')}${sourceCountryRef.value === COUNTRY.JP && !showTiktok.value && shopInfo.value.authStatus === '1' ? `/${t('处理中库存使用数')}` : ''}`
  }

  return [
    { label: '商品名称', name: 'title', width: 260, headerWidth: 210 },
    { label: t('客户商品sku'), name: 'customSku', width: 140 },
    { label: '商品属性', name: 'sku', width: 110 },
    { label: '下单数量', name: 'amount', width: 120 },
    { label: title, name: 'store', width: isEN() ? 130 : 110 },
    { label: t('单价') + tCurrency('CNY'), name: 'price', width: 110 },
    { label: t('小计') + tCurrency('CNY'), name: 'total', width: 110 },
    { label: '商品附加项', name: 'adt', width: 150 },
    { label: '操作', name: 'run', width: 70 }
  ].fort()
})
/** 是否显示 choice 商品列表 */
const showChoice = computed(() => {
  const fixedChoiceShow = choiceCartList.value.length && isJA()
  return (isChoiceShop() && ((isD2C() && mode.value === 1) || !isD2C()) && sourceCountryRef.value === COUNTRY.CN) || (fixedChoiceShow && ((isD2C() && mode.value === 1) || !isD2C()))
})

/** 直发/囤货模式及对应的购物车列表布局 */
const modes = computed(() => [
  {
    label: 'C端直发',
    value: 1,
    img: require('@/assets/image/d2c.jpg'),
    layout: Layout2.value
  },
  {
    label: '采购到库存',
    value: 0,
    img: require('@/assets/image/b2b.jpg'),
    layout: Layout1
  }
].fort())
/** 备货到日本组件 */
const stockJpRef = ref()
/** 直发/囤货模式 */
const mode = ref(isD2C() ? 1 : 0)
/** 购物车列表显示表头布局 */
const layout = computed(
  () => modes.value.find((v) => v.value === mode.value)?.layout ?? []
)
/** 地址校验 */
const addressValid = ref(() => Promise.resolve(null))
/** 用户会员信息 */
const membership = store.getters.membership

const cnWareName = computed(() => {
  return (store.getters.shopReplenishInfo?.warehouseList ?? [])?.find(v => v.warehouseCountry === 'CN')?.warehouseNameTranslate ?? t('中国')
})
/** 一键下单的在途库存弹窗 */
const confirmStockModal = ref()
/** 购物车列表数据 */
const list = ref<CartGroupItemDTO[]>([])
/** 购物车勾选数据 cartId */
const listCheckMap = ref<Record<number, boolean>>({})
let oldListCheckMap: any = {}
/** 是否禁用下单按钮 */
const disabled = computed(
  () => (Object.values(listCheckMap.value).filter((v) => v).length === 0 && Object.keys(checkMap.value)?.length === 0)
)
/** 筛选勾选后有商品的购物车 id */
const cartIdList = computed(() =>
  Object.entries(listCheckMap.value)
    .filter((ety) => ety[1])
    .map(([k]) => k)
)

/** 所有勾选的商品数据 */
const checkList = computed(() => {
  const arr: any = []
  list.value.forEach((v) => {
    v.cartList?.forEach((item) => {
      listCheckMap.value[item.cartId!] && arr.push(item)
    })
  })
  return arr
})

/** 失效商品数据判断 */
const isInvalid = (item: any) => {
  if (mode.value === 1) {
    // 直发没有库存并失效的才算
    return ([1, 2, 6, 7].includes(item.productStatus) || item.blackTag) && item.stockQuantity === 0
  }
  return [1, 2, 6, 7].includes(item.productStatus) || item.blackTag
}
/**
 * 将商品区分为失效商品和正常商品加上标记并返回一个列表
 * @param cartList
 */
const margeListData = (cartList: any) => {
  console.log(cartList)
  const invalidGoods: any = {
    cartList: [],
    disabled: true,
    cartGroupName: t('失效商品'),
    invalidGoods: true
  }
  const normalList: any = []
  cartList.forEach((item: any) => {
    if (item.cartList.filter((v: any) => !isInvalid(v)).length > 0) {
      normalList.push({
        ...item,
        cartList: item.cartList.filter((v: any) => !isInvalid(v))
      })
    }
    item.cartList?.forEach((cartItem: any) => {
      if (isInvalid(cartItem)) {
        invalidGoods.cartList.push(cartItem)
      }
    })
  })
  return [
    ...normalList,
    ...(invalidGoods.cartList.length > 0 ? [invalidGoods] : [])
  ]
}

/**
 * 参数：直发，囤货，商品所在地（中国/韩国），仓库所在地（中国/日本）
 * 获取购物车列表 （此处会根据）
 */
const getData = () => {
  store.commit('status/loading', true)
  return request.order.cart.list({
    orderType: mode.value === 1 ? 1 : 2,
    goodsCountry: sourceCountryRef.value === COUNTRY.KR ? COUNTRY.KR : COUNTRY.CN,
    wareHouseLocation: sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN
  }).then(async (res) => {
    if (res?.success) {
      const cartList = margeListData(res.data) as any[]
      cartList.forEach((item) => {
        item.cartList?.forEach((cartItem:any) => {
          // 如果oemBusinessType ===2 小单快反的商品默认producttype为2，走pem逻辑
          if (cartItem.oemBusinessType === 2) {
            cartItem.oldProductType = cartItem.productType
            cartItem.productType = 2
          }
          // 新增原始库存字段，使用商品stockQuantity字段
          cartItem.originalstockQuantity = cartItem.stockQuantity ?? 0
          // 增加是否存在阶梯价字段 一件代发商品都存在阶梯价所以productPriceLadderList不准了
          cartItem.noPriceLadder = !cartItem.productPriceLadderList?.length
          // 组合商品子商品
          if (cartItem?.combinationProductItemList?.length) {
            cartItem?.combinationProductItemList?.forEach((comItem: any) => {
              // 组合子商品是否存在阶梯价
              comItem.noPriceLadder = !comItem.productPriceLadderList?.length
              // 新增原始库存字段，使用商品stockQuantity字段
              comItem.originalstockQuantity = comItem.stockQuantity ?? 0
            })
          }
          // 直播商品去掉区间价
          if (cartItem.livePriceFlag === 1) {
            cartItem.productPriceLadderList = null
            // 直播商品不走一件代发逻辑
            cartItem.isOnePsale = false
          }

          // 子商品带阶梯价且是一件代发商品需要把一件代发价补充到productPriceLadderList第一个
          if (cartItem?.productPriceLadderList?.length && cartItem.isOnePsale) {
            if (cartItem.productPriceLadderList[0].count !== 1) {
              cartItem.productPriceLadderList.unshift({
                count: 1,
                price: cartItem.consignPrice,
                isOnePsale: true
              })
            }
          }
          // 没有阶梯价且是一件代发
          if (!cartItem.productPriceLadderList?.length && cartItem.isOnePsale) {
            cartItem.productPriceLadderList = [
              {
                count: cartItem.minOrderQuantity,
                price: cartItem.productSellPrice
              }
            ]
            if (cartItem.minOrderQuantity && cartItem.minOrderQuantity > 1) {
              cartItem.productPriceLadderList.unshift({
                count: 1,
                price: cartItem.consignPrice,
                isOnePsale: true
              })
            }
          }
        })
      })
      list.value = cartList
    }
  }).finally(() => {
    store.commit('status/loading', false)
  })
}

const update = () => getData().then(calcPrice)
// 其他地方更改购物车后触发更新
store.commit('goods/useUpdate', update)
// 监听发货仓切换
// watchSourceCountry(async () => {
//   listCheckMap.value = {}
//   list.value = []
//   await init()
// })
// 切换直发 囤货重新触发
watch(mode, () => {
  isReady.value = false
  if (mode.value === 2) return
  listCheckMap.value = {}
  init()
})
const isTikTokShop2C = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C())

/**
 * 计算商品阶梯价和附加费
 */
const calcPrice = async () => {
  // 整理购物车数据
  const [skuList, group, groupGoods] = await flatCart(
    {
      list: list.value,
      listCheckMap: listCheckMap.value,
      mode: mode.value,
      isUseOnTheWayStock: isUseOnTheWayStock.value,
      sourceCountry: sourceCountryRef.value
    }
  )

  flatList.value = skuList
  // 组合使用落单子商品需传的参数 严重 bug（此处永远返回空数组，勿动!!!）
  remainList.value = await setStock(groupGoods, mode.value, listCheckMap.value)

  // 算价逻辑
  await calcLadder(skuList, listCheckMap.value, !mode.value)
  await calcGp(group, mode.value)
  calcFee()
  console.log(list.value, 'list.value1')
}

const scrollBarFn = () => {
  let itemIndex = 0
  let tempIndex = 0
  let isReturn = false
  list.value.forEach((item: any, index: any) => {
    if (isReturn) return
    itemIndex++
    item.cartList.forEach((temp: any, key: any) => {
      if (temp.shitProp) {
        isReturn = true
      }
      if (isReturn) return
      tempIndex++
    })
  })
  const ele: any = document.querySelector('.el-scrollbar>.el-scrollbar__wrap')
  ele.scrollTo(0, (isD2C() ? (mode.value === 1 ? 376.5 : 167.5) : 141.5) + (itemIndex * 66) + (110 * tempIndex) + (itemIndex - 1) * 30)
}
const remainList = ref([])
const flatList = ref([])

watch([cartIdList], calcPrice)
watch(() => mode.value, calcPrice)
/** 所有商品 sku */
let sku: string[] = []
/**
 * 购物车初始化函数
 * @param type type 是否刷新后保留原先勾选状态
 */
const init = async (type?: boolean) => {
  //   当为直发单才需要判断是否在途库存
  if (mode.value === 1) {
    await initIsCanUseOnTheWayStock()
  } else {
    isCanUseOnTheWayStock.value = false
  }

  getData().then(() => {
    sku = []
    list.value.forEach((v) => {
      v.cartList?.forEach((item) => {
        // 默认不勾选
        listCheckMap.value[item.cartId!] = type ? oldListCheckMap[item.cartId!] : false
        // 如果notInStorage不为0不能勾选
        if (item.notInStorage === 0) {
        } else {
          // 处理插件加购时需要更新的sku
          item.productSku && sku.push(item.productSku)
        }
      })
    })
    // 插件数据更新逻辑
    if (sku.length > 0) {
      setTimeGetStock()
    }
    calcPrice(type)
    isReady.value = true
  })
  // if (!isChoiceShop) return
  choiceFn.getChoiceList(mode.value)
}
/** 备货到日本后端灰度状态 */
const showBtn = ref(false)
// 是否弹过
const isOpenFreeVipDialog = ref(false)
const isNewVip = ref(false)
const activityInfo:any = ref({})
onMounted(async () => {
  // 获取新用户返现活动信息
  if (isJA()) {
    getDeliveryCashbackActivityApi().then((res) => {
      console.log('sadasdad', res, store.getters.user?.createTime)
      if (!res.data?.activityInfo) return
      // 用户注册时间在活动期间内
      const isBetweenActiveRegist = dayjs(store.getters.user?.createTime).isAfter(dayjs(res.data?.activityInfo?.startDate)) && dayjs(store.getters.user?.createTime).isBefore(dayjs(res.data?.activityInfo?.endDate))
      console.log('是否在活动期间注册', isBetweenActiveRegist)
      // 用户活动是否还在进行中，用户注册时间在活动期间内并且 按照券30天过期时间算是否展示
      const isHaveActivity = isBetweenActiveRegist && dayjs(store.getters.user?.createTime).add(res.data.activityInfo.validTime!, 'day').isAfter(dayjs())
      console.log('活动是否进行中', isHaveActivity, dayjs(store.getters.user?.createTime).add(res.data.activityInfo.validTime!, 'day'))
      activityInfo.value = {
        ...res.data?.activityInfo,
        isHaveActivity,
        isBetweenActiveRegist,
        remainingBalance: Number(res.data?.activityInfo?.thresValue) - res.data?.totalOrderAmount,
        // 当前时间是否在活动时间内
        isShowBanner: res?.data?.activityInfo?.endDate ? dayjs(res?.data?.activityInfo?.endDate).isAfter(dayjs()) : false,
        // 是否完成
        isComplete: res.data?.totalOrderAmount >= Number(res.data?.activityInfo?.thresValue),
        endActivityDate: dayjs(store.getters.user?.createTime).add(res.data.activityInfo.validTime!, 'day').format('YYYY/MM/DD')
      }
    })
  }
  init()
  store.dispatch('status/setShopReplenishInfo')
  if (isTikTokShop2C.value) {
    const res = await request.order.cart.validTkWhiteUser({})
    isTiktokWhite.value = res.data!
  }
  // setConfig('2')

  const resData = await isFirstPayVipApi({})
  isNewVip.value = !resData.data
  checkOpenStatus()
})
const checkOpenStatus = async () => {
  // setConfig('2')
  // setConfig2('2')
  if (isNewVip.value) {
    const data = await getConfig()
    isOpenFreeVipDialog.value = data === '1'
  } else {
    const data = await getConfig2()
    isOpenFreeVipDialog.value = data === '1'
  }
}
/** 用户是否可以使用在途库存 */
const isCanUseOnTheWayStock = ref(false)
/** 用户是否选择使用在途库存 */
const isUseOnTheWayStock = ref(false)
/** 是否可以使用在途函数 */
const initIsCanUseOnTheWayStock = async () => {
  const data = await canUseOnTheWayStockApi()
  isCanUseOnTheWayStock.value = data.data
}
let timer: any = null
/** （插件入库）定时查询购物车未入库商品状态 */
const setTimeGetStock = () => {
  clearTimeout(timer)
  if (sku.length === 0) return
  searchIsInStoreApi({
    productSkuList: sku
  }).then((res) => {
    if (res.success && res.data.length > 0 && route.meta.name === 'shopcart') {
      // 数据有更新，重新刷新列表
      timer = setTimeout(() => {
        init()
      }, 2000)
    } else if (route.meta.name === 'shopcart') {
      timer = setTimeout(() => {
        setTimeGetStock()
      }, 2000)
    }
  })
}

// 获取在途库存数量并更新到购物车列表
const getTheWayStock = async () => {
  //   选中的shopProductSku集合,需要请求在途库存数量
  const shopProductSkus = new Set()
  checkList.value?.forEach((item: any) => {
    // 如果是组合商品，则将子商品的sku传进去，主商品就不用传进去
    if (item.combinationProductItemList?.length) {
      item.combinationProductItemList.forEach((comitem: any) => {
        shopProductSkus.add(comitem.shopProductSku)
      })
    } else {
      shopProductSkus.add(item.shopProductSku)
    }
  })
  if (!(isTikTokShop2C.value && !isTiktokWhite.value)) {
    //   请求在途库存列表
    const data = await pageOrderOnTheWayStockApi({ shopProductSkus: Array.from(shopProductSkus), goodsCountry: sourceCountryRef.value !== COUNTRY.KR ? COUNTRY.CN : COUNTRY.KR, pageNum: 1, pageSize: 300, wareHouseLocation: sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN })
    const onTheWayStockList: any[] = data?.data?.records ?? []
    //   如果在途列表没有就直接不进行下面操作
    if (!onTheWayStockList.length) {
      return
    }

    checkList.value.map(async (item: any) => {
      // 如果是组合商品，则直接循环子商品是否有在途，目前没有主商品使用在途的概念
      if (item.combinationProductItemList?.length) {
        item.combinationProductItemList.forEach((comItem: any) => {
          const sigleOnTheWayStock = onTheWayStockList?.find(wayItem => wayItem.shopProductSku === comItem.shopProductSku)
          const onTheWayAvailableNum = Number(sigleOnTheWayStock?.onTheWayAvailableNum ?? 0)
          comItem.onTheWayAvailableNum = onTheWayAvailableNum
        })
      } else {
        // 一一匹配，将库存加上在途库存的值
        const sigleOnTheWayStock = onTheWayStockList?.find(wayItem => wayItem.shopProductSku === item.shopProductSku)
        const onTheWayAvailableNum = Number(sigleOnTheWayStock?.onTheWayAvailableNum ?? 0)
        item.onTheWayAvailableNum = onTheWayAvailableNum
      }
    })
  }
}

watch([() => isJpNoTikTokShop.value, () => checkList.value], async () => {
  if (isJpNoTikTokShop.value) {
    isUseOnTheWayStock.value = true
    await getTheWayStock()
    await calcPrice()
  }
}, {
  immediate: true
})

/** 监听是否选择在途库存 */
watch(isUseOnTheWayStock, async (newValue) => {
  await getTheWayStock()
  if (!(isTikTokShop2C.value && !isTiktokWhite.value)) {
    calcPrice()
  }
})

/** 商品价格 */
const pdtFee = ref(0)
/** 附加项价格 */
const adtFee = ref(0)
/** 囤货商品同样计算在内的订单价值 直发不可超过一定金额 */
const valueFee = ref(0)
/** 本期支付总金额 */
const curPdtFee = ref(0)
// d2c直发最大金额
const D2CMaxMoney = computed(() => store.getters['d2cOrderAmount/getD2cMoney'])
const calcFee = () => {
  let m = 0
  let n = 0
  let l = 0
  let p = 0
  checkList.value.forEach((item: any) => {
    m += item.totalPrice
    n += item.adtPrice ?? 0
    l += item.valuePrice
    p += item.curPdtPirce
  })

  pdtFee.value = m
  adtFee.value = n
  valueFee.value = l
  curPdtFee.value = p
}

const createGroup = () => {
  const data = checkList.value
  const g = data.find((v: any) => v.productType === 3)
  const o = data.find((v: any) => [1, 3].includes(v.oemOrderType))
  if (g) {
    ElMessage.error(t('组合商品不能再组合'))
  } else if (o) {
    ElMessage.error(t('OEM样品单不能组合'))
  } else {
    store.commit('goods/groupList', data)
    router.push(useRtfix('groupProduct', { query: { from: 'cart' } }))
  }
}

const preview = ref(false)
const openMemberRef = ref()
/** 点击提出后第二步 */
const commitConfirm = async () => {
  let isWarn = false
  // 提交订单前 校验商品是否失效下架
  if (checkList.value.filter((i: any) => (mode.value === 0 && i.productType !== 3) || mode.value === 1)?.length > 0) {
    isWarn = await isHaveErrorGoods()
  }
  if (isWarn) {
    oldListCheckMap = listCheckMap.value
    listCheckMap.value = {}
    init(true)
    return
  }
  preview.value = true
}

// 是否超库存限制
const isExtStock = computed(() => (checkList.value.some((goods: any) => (goods.productType === 3) ? goods.combinationProductItemList.some(i => i.buyQuantity > 0) : goods.orderQuantity > goods.stockQuantity)) && (isTikTokShop2C.value && !isTiktokWhite.value) && mode.value === 1)

const orderExhausted = ref()
// 提出
const commit = async (type?:any) => {
  // type新会员弹窗 用来判断是不是点击弹窗后再次提交
  confirmFreeVipDialog.value = type === 1
  if (type === 1) {
    await checkOpenStatus()
  }
  checkShopCartStatus(5)
  if (disabled.value) return
  // choice 购物车
  if (cartGoodsMode.value === 2) {
    if (mode.value === 1) {
      const valid = await addressValid.value()
      if (!valid) {
        ElMessage.error(t('请将收货人信息填写完整后提交订单'))
        return
      }
    }

    // 校验起订量
    console.log('checkMap.value', checkMap.value)
    if (Object.values(checkMap.value).some((v: any) => choiceFn.getCartIdLackStatus(v).lack || choiceFn.getCartIdLackStatus(v).goodsLack)) {
      ElMessage.error(t('存在不足起订量的商品，请修改数量'))
      return
    }

    if (Object.values(checkMap.value).some((v: any) => !v.cartAdditionList?.length && v.noAdditionalFlag !== 1)) {
      ElMessage.error(t('附加项验证'))
      return
    }

    if (cartGoodsMode.value === 2) {
      store.commit('status/loading', true)
      await updateShopcartApi({
        productCodes: Object.values(checkMap.value).map(v => v.productCode)
      }).finally(() => {
        store.commit('status/loading', false)
      })
    }
    choiceConfirmOrdeRef.value.open()
    return
  }

  // 普通购物车校验
  const noAddList: any = []
  checkList.value.forEach((v: any) => {
    if (v.productType !== 3) {
      if (v.buyQuantity === 0) return
      if (!(v.cartAdditionList?.length || v.noAdditionalFlag)) {
        noAddList.push(v)
      }
    } else {
      v.combinationProductItemList.forEach((v2: any) => {
        if (v.buyQuantity === 0) return
        if (!(v2.additionList?.length || v2.noAdditionalFlag)) {
          noAddList.push(v2)
        }
      })
    }
  })
  if (noAddList.length && !isJpTitkTokShop.value) {
    const first = noAddList[0].cartId ?? noAddList[0].shopProductSku
    const top = document.getElementById(first)?.getBoundingClientRect()?.top ?? 180
    store.commit('observe/trigger', { scroll: top - 270 + store.state.observe.scroll })
    //
    noAddList.forEach((v: any) => {
      v.showTip = true
      setTimeout(() => { v.showTip = false }, 1000)
    })
    ElMessage.error(t('附加项验证'))
    return
  }
  // tiktok直发单校验库存

  if (mode.value === 1) {
    // 是否超库存购买
    if (isExtStock.value) {
      ElMessage.error(t(t('超出库存，无法下单，请提前备货')))
      return
    }
    const { data: money } = await getD2cMoneyApi({ currencyCode: sourceCountryInfo.value?.currency })
    // 拦截金额按照附加项 + 商品实际金额 日本仓无需校验金额
    if ((valueFee.value + adtFee.value) > money && (sourceCountryRef.value !== COUNTRY.JP)) {
      ElMessage.error(
        t('单笔订单价值不得超过XX元，请调整商品数量').replace(
          'XX',
          String(money)
        ).replace('元', tCurrency('元'))
      )
      return
    }
    const valid = await addressValid.value()
    if (!valid) {
      ElMessage.error(t('请将收货人信息填写完整后提交订单'))
      return
    }
  }
  if (flatList.value.some((v: any) => v.lack)) {
    ElMessage.error(t('存在不足起订量的商品，请修改数量'))
    return
  }
  if (mode.value === 0) {
    console.log('checkList.value', checkList.value)
    // 日本站 中国仓 如果是囤货模式下 校验是否是会员，如果没有会员并且是第一次弹窗则弹出提示
    console.log(sourceCountryRef.value, isJA(), !confirmFreeVipDialog.value, !isOpenFreeVipDialog.value)
    if (sourceCountryRef.value === COUNTRY.CN && isJA() && !confirmFreeVipDialog.value && !isOpenFreeVipDialog.value && (store.getters.user?.membership.templateLevel === 0 || new Date(store.getters.user?.membership.expiresDate).getTime() < new Date().getTime())) {
      const list:any = []
      checkList.value.forEach((item:any) => {
        if (item.productType === 3) {
          item.combinationProductItemList?.forEach((temp:any) => {
            list.push({
              productSku: temp.productSku,
              num: temp.orderQuantity
            })
          })
          return
        }
        list.push({
          productSku: item.productSku,
          num: item.orderQuantity
        })
      })
      const res = await feeVipTipRef.value.open({
        skuList: list
      })
      if (res) {
        // 如果入会金额大于需要非会员金额弹窗展示
        return
      }
    }
  }
  judgeCanUseOnTheWayStock()
}
const feeVipTipRef = ref()
// 是否确认过免费会员弹窗
const confirmFreeVipDialog = ref(false)
/** 判断是否可以使用在途库存,是否打开在途确认页 */
const judgeCanUseOnTheWayStock = async () => {
  if (mode.value !== 1 || !isCanUseOnTheWayStock.value) {
    commitConfirm()
    return
  }
  //   选中的shopProductSku集合
  //   const shopProductSkus = checkList.value?.map(item => item.shopProductSku)
  const shopProductSkus = new Set()
  checkList.value?.forEach((item: any) => {
    // 如果是组合商品，则将子商品的sku传进去，主商品就不用传进去
    if (item.combinationProductItemList?.length) {
      item.combinationProductItemList.forEach((comitem: any) => {
        shopProductSkus.add(comitem.shopProductSku)
      })
    } else {
      shopProductSkus.add(item.shopProductSku)
    }
  })
  if (!(isTikTokShop2C.value && !isTiktokWhite.value)) {
    //   当为直发单，且账号处于可以使用在途库存白名单内
    const data = await hasOrderAvailableTransportationNums({ shopProductSkus: Array.from(shopProductSkus), goodsCountry: sourceCountryRef.value !== COUNTRY.KR ? COUNTRY.CN : COUNTRY.KR, wareHouseLocation: sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN })
    if (data?.data) {
      confirmStockModal.value.open(sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN)
      return
    }
  }
  commitConfirm()
}
/** 在途库存弹窗确认 */
const confirmStockSuccess = async (val: boolean) => {
  isUseOnTheWayStock.value = val
  commitConfirm()
}

const isHaveErrorGoods = () => {
  return request.order.cart.createOrderPreCheck({
    orderType: mode.value === 1 ? 1 : 2,
    wareHouseLocation: mode.value === 1 && sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN,
    // 组合商品囤货不校验失效商品库存
    cartIds: checkList.value.filter((i: any) => (mode.value === 0 && i.productType !== 3) || mode.value === 1).map((item: any) => item.cartId)
  }).then((res: any) => {
    const { invalidProductSkuList, banProductSkuList, stockNotEnoughList } = res.data
    let errorText = ''
    if (invalidProductSkuList.length > 0 || banProductSkuList.length > 0) {
      const map = arr2map([
        ...invalidProductSkuList,
        ...banProductSkuList
      ])
      const sku: any[] = []
      checkList.value.forEach((v: any) => {
        if (v.productType === 3 && mode.value === 1) {
          v.combinationProductItemList.forEach((item: any) => {
            sku.push(item)
          })
        } else {
          sku.push(v)
        }
      })
      sku.some(v => {
        if (map.get(v.productSku)) {
          console.log(v.productSku, { ...v }, { isHaveErrorGoods })
          if (v.onTheWayStockQuantity < v.orderQuantity) {
            errorText = invalidProductSkuList.length > 0 && banProductSkuList.length > 0 ? t('多个商品有异常，请重新调整商品') : invalidProductSkuList.length > 0 ? t('存在已失效商品，请调整商品') : t('存在已下架商品，请调整商品')
            return true
          }
        }
      })
    }
    if (stockNotEnoughList.length > 0) {
      errorText = errorText ? t('多个商品有异常，请重新调整商品') : t('存在库存过低商品，请调整发货量或及时补充库存')
      console.log('库存不足', checkList.value, stockNotEnoughList)
      const underlineGoos = checkList.value.filter((i: any) => stockNotEnoughList.includes(i.productSku))
      if (underlineGoos.length > 0) {
        // 线下商品库存不足的时候弹窗
        noStockVisible.value = true
        noStockGoods.value = underlineGoos
        return true
      }
    }
    if (!errorText) {
      return false
    } else {
      ElMessage({
        dangerouslyUseHTMLString: true,
        message: errorText,
        type: 'error'
      })
      return true
    }
  })
}
const success = async (fn: any) => {
  preview.value = false
  const vals: any = []
  checkList.value.forEach((v: any) => {
    if (v.oemProductClassificationId === 3) {
      vals.push(v.shopProductSku)
    }
  })
  Object.entries(listCheckMap.value).forEach(([k, v]) => {
    v && delete listCheckMap.value[k]
  })
  // 查询下单商品是否有未绑定的辅料
  let hasIngt = false
  if (vals.length) {
    hasIngt = await getRelIngt({ ingredientsSkuList: [...vals] }).then((res) => {
      return res.data.filter((v: any) => v.relatedFlag).length !== vals.length
    })
  }
  await update()
  fn(hasIngt)
}

// 是否数量超过2
const isNumberExceed: any = computed(() => {
  let number = 0
  list.value.forEach((v: any) => {
    v.cartList.forEach((v: any) => {
      if (cartIdList.value.includes(v.cartId)) {
        number += v.orderQuantity
      }
    })
  })
  return number > 1 || totalAmount.value.totalQuantity > 1
})
// 下单购买商品总数量
const totalBuyQuantity: any = computed(() => {
  let number = 0
  list.value.forEach((v: any) => {
    v.cartList.forEach((v: any) => {
      if (cartIdList.value.includes(v.cartId)) {
        number += v.orderQuantity
      }
    })
  })
  return number
})
/** 非提交时，关闭在途库存弹窗，则不使用在途 */
const confirmStockClose = (iscommit: boolean) => {
  if (!iscommit) {
    isUseOnTheWayStock.value = false
  }
}

const close = (isReload?: boolean | number, stockList?: any) => {
  isUseOnTheWayStock.value = false
  preview.value = false

  if (isReload === 1) {
    init()
    return
  }
  if (isReload) {
    if (stockList?.length > 0) {
      noStockVisible.value = true
      noStockGoods.value = stockList
    }
    // 如果存在异常商品重新刷新购物车列表
    oldListCheckMap = listCheckMap.value
    listCheckMap.value = {}
    init(true)
  }
}

// 线下商品没有库存的情况下展示提示弹窗
const noStockVisible = ref(false)
const noStockGoods = ref([])
const customsCallback = () => {
  getKrStatus()
}

const getKrStatus = () => {
  if (!isD2C() && isKO()) {
    // 2b 和韩国站才调用
    getIsShowCustomsApi({
      type: 1
    }).then((res: any) => {
      if (res.success) {
        isShowKrTip.value = res.data
      }
    })
  }
}
// 是否需要弹韩国站
const isShowKrTip = ref(false)
getKrStatus()

bus.on('microappUpdateCart', (k: string) => {
  init()
})

// bus.on('orderExhausted', () => {
//   orderExhausted.value?.check()
// })

/**
 * xxx
 * choice 商品逻辑处理
 * xxx
 * xxx
 */
const choiceConfirmOrdeRef = ref()
const { choiceCartList, choiceFn, transportType, changeTransportType, totalAmount, checkMap, requestNum } = useChoice()
const tabStatus = ref(1)
const goodsTableRef = ref()
const choiceTableRef = ref()

watch(() => store.state.observe.scroll, (newValue) => {
  if (goodsTableRef.value?.getBoundingClientRect()?.top < 185) {
    tabStatus.value = 1
  }
  if (choiceTableRef.value?.getBoundingClientRect()?.top < 185) {
    tabStatus.value = 2
  }
}, {
  immediate: true
})
const changeTab = (type: number) => {
  const top = goodsTableRef.value?.offsetTop ?? 0
  const height = goodsTableRef.value?.getBoundingClientRect()?.height ?? 0
  console.log(mode.value, height, goodsTableRef.value.offsetTop)
  const scorllObj: any = {
    // 直发
    1: {
      // 代采
      1: top - 52,
      // choice
      2: top + height
    },
    // 囤货
    0: {
      // 代采
      1: top - 52,
      // choice
      2: top + height
    }
  }
  store.commit('observe/trigger', { scroll: scorllObj[mode.value][type] })
  tabStatus.value = type
}

// 0 1代采 2choice
const cartGoodsMode = computed(() => {
  return Object.keys(checkMap.value)?.length > 0 ? 2 : cartIdList.value?.length > 0 ? 1 : 0
})

const normalCartGoodsNumber = computed(() => {
  return list.value.reduce((acc: number, v: any) => v.cartList?.length + acc, 0)
})
const choiceCartGoodsNumber = computed(() => {
  return choiceCartList.value.reduce((acc: number, v: any) => v.cartList?.length + acc, 0)
})

const supportLiveDevice = computed(() => store.getters.shopInfo?.supportLiveDevice)

watch(() => supportLiveDevice.value, () => {
  if (supportLiveDevice.value) {
    tabStatus.value = 2
    nextTick(() => {
      changeTab(2)
    })
  }
}, {
  immediate: true
})
const switchDeliverRef = ref()
// 校验购物车当前状态是否可以下单
// currentStatus 1:填写地址 2 填写发货附加项 3选择商品 4选择商品附加项 5 点击提交
const checkShopCartStatus = async (currentStatus: number) => {
  if (!isJA()) return
  await new Promise(resolve => setTimeout(resolve, 100))
  const shopcartStatus = {
    currentStatus,
    addressStatus: true,
    deliverStatus: true,
    chooseGoodsStatus: true,
    goodsAdditionStatus: true
  }
  if (isD2C()) {
    // 校验地址
    const valid = await addressValid.value()
    if (!valid) {
      shopcartStatus.addressStatus = false
    }
  }
  // 校验发货附加项
  if (!switchDeliverRef.value?.model?.deliveryAdditionalList?.length) {
    shopcartStatus.deliverStatus = false
  }
  // 校验商品
  if (cartGoodsMode.value === 0) {
    shopcartStatus.chooseGoodsStatus = false
    shopcartStatus.goodsAdditionStatus = false
  } else {
    // 校验附加项区分choice和普通商品
    if (cartGoodsMode.value === 2) {
      // 日本商品
      if (Object.values(checkMap.value).some((v: any) => !v.cartAdditionList?.length && v.noAdditionalFlag !== 1)) {
        shopcartStatus.goodsAdditionStatus = false
      } else {
        shopcartStatus.goodsAdditionStatus = true
      }
    } else {
      // 中国商品
      const noAddList: any = []
      checkList.value.forEach((v: any) => {
        if (v.productType !== 3) {
          if (v.buyQuantity === 0) return
          if (!(v.cartAdditionList?.length || v.noAdditionalFlag)) {
            noAddList.push(v)
          }
        } else {
          v.combinationProductItemList.forEach((v2: any) => {
            if (v.buyQuantity === 0) return
            if (!(v2.additionList?.length || v2.noAdditionalFlag)) {
              noAddList.push(v2)
            }
          })
        }
      })
      if (noAddList.length && !isJpTitkTokShop.value) {
        shopcartStatus.goodsAdditionStatus = false
      } else {
        shopcartStatus.goodsAdditionStatus = true
      }
    }
  }
  bus.emit('checkShopcartStatus', {
    ...shopcartStatus
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CommonTip, {
        name: _unref(isD2C)() ? 'stopWarehouse,stopPurchaseOrder,stopPurchase' : 'stopPurchase,stopPurchaseOrder'
      }, null, 8, ["name"])
    ]),
    (_unref(isJA)())
      ? (_openBlock(), _createBlock(CreateOrderGuide, {
          key: 0,
          mode: mode.value
        }, null, 8, ["mode"]))
      : _createCommentVNode("", true),
    (activityInfo.value.isShowBanner)
      ? (_openBlock(), _createElementBlock("a", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "tabs"),
          (!_unref(isD2C)() && !_unref(supportLiveDevice))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "upload-file-btn abs",
                style: _normalizeStyle({ top: _unref(membership).templateLevel === 0 ? '18px' : '18px' })
              }, [
                _createVNode(UploadFileBtn, {
                  mode: 0,
                  onSuccess: init,
                  isCanUseOnTheWayStock: isCanUseOnTheWayStock.value
                }, null, 8, ["isCanUseOnTheWayStock"])
              ], 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["top", { 'top-bo-border': _unref(isMultiStore)() }])
          }, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('购物车')), 1)
            ])
          ], 2),
          (_unref(isJA)())
            ? (_openBlock(), _createBlock(FreeShipping, {
                key: 1,
                scene: 2,
                style: {"padding-top":"10px"}
              }))
            : _createCommentVNode("", true),
          _hoisted_9,
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(SwitchDeliver, {
                key: _unref(sourceCountryRef),
                isCanUseOnTheWayStock: isCanUseOnTheWayStock.value,
                mode: mode.value,
                "onUpdate:mode": _cache[0] || (_cache[0] = ($event: any) => ((mode).value = $event)),
                modes: _unref(modes),
                onUpdateDeliver: _cache[1] || (_cache[1] = (data) => (addressValid.value = data)),
                onSuccess: _cache[2] || (_cache[2] = ($event: any) => (mode.value === 0 && init())),
                checkList: _unref(checkList),
                isChoice: _unref(cartGoodsMode) === 2,
                showBtn: showBtn.value,
                ref: (_value, _refs) => {
                  _refs['switchDeliverRef'] = _value
                  switchDeliverRef.value = _value
                },
                onCheckStatus: _cache[3] || (_cache[3] = e => checkShopCartStatus(e))
              }, null, 8, ["isCanUseOnTheWayStock", "mode", "modes", "checkList", "isChoice", "showBtn"]))
            : _createCommentVNode("", true),
          ([0, 1].includes(mode.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (mode.value === 0 && _unref(isD2C)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('THE CKB日本仓功能已上线，提前备货到日本仓享高效履约服务。')), 1),
                        _createElementVNode("a", {
                          style: {"margin-top":"4px","display":"inline-block","cursor":"pointer"},
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (figurePayRef.value.scrollToEdit()))
                        }, _toDisplayString(_unref(t)('请切换囤货目的仓库')) + ">", 1)
                      ]),
                      _hoisted_14,
                      _createElementVNode("a", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('新手操作引导')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "guide-num-line",
                      style: _normalizeStyle([{"margin-bottom":"10px"}, {marginTop: mode.value === 0 ? '20px' : ''}])
                    }, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(mode.value === 0 ? (_unref(isD2C)() ? 2 : 1) : 4), 1),
                      _hoisted_18
                    ], 4))
                  : _createCommentVNode("", true),
                (_unref(showChoice) || _unref(supportLiveDevice))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "goods-tab",
                      style: _normalizeStyle({top: _unref(isJA)() ? '199px': '115px'})
                    }, [
                      (!_unref(supportLiveDevice))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["goods-tab-item", { active: tabStatus.value === 1 }]),
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (changeTab(1)))
                          }, _toDisplayString(_unref(t)('代采商品')) + _toDisplayString(_unref(normalCartGoodsNumber) > 0 ? `(${_unref(normalCartGoodsNumber)})` : ''), 3))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["goods-tab-item", { active: tabStatus.value === 2 }]),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (changeTab(2)))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('Choice商品')) + _toDisplayString(_unref(choiceCartGoodsNumber) > 0 ? `(${_unref(choiceCartGoodsNumber)})` : ''), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createTextVNode(_toDisplayString(_unref(t)('一口价')) + " ", 1),
                          _hoisted_20
                        ])
                      ], 2)
                    ], 4))
                  : _createCommentVNode("", true),
                (!_unref(supportLiveDevice))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      ref: (_value, _refs) => {
                        _refs['goodsTableRef'] = _value
                        goodsTableRef.value = _value
                      }
                    }, [
                      _createVNode(ShopTable, _mergeProps({
              cartIdList: _unref(cartIdList),
              listCheckMap: listCheckMap.value,
              list: list.value,
              layout: _unref(layout),
              mode: mode.value,
              refKey: _unref(sourceCountryRef),
              choiceDisabled: _unref(cartGoodsMode) === 2,
              checkList: _unref(checkList),
              showChoice: _unref(showChoice),
              isJpTitkTokShop: _unref(isJpTitkTokShop),
              isTiktokWhite: isTiktokWhite.value,
              activityInfo: activityInfo.value
            }, {
                        onUpdate: update,
                        onCalc: calcPrice,
                        onCheckStatus: _cache[7] || (_cache[7] = e => checkShopCartStatus(4)),
                        pdtFee: pdtFee.value,
                        adtFee: adtFee.value,
                        curPdtFee: curPdtFee.value
                      }), null, 16, ["pdtFee", "adtFee", "curPdtFee"])
                    ], 512))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(PriceRate)
                  ]),
                  _: 1
                })),
                (_unref(showChoice) || _unref(supportLiveDevice))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      ref: (_value, _refs) => {
                        _refs['choiceTableRef'] = _value
                        choiceTableRef.value = _value
                      }
                    }, [
                      _withDirectives(_createVNode(ChoiceShopTable, _mergeProps({
              list: _unref(choiceCartList),
              choiceFn: _unref(choiceFn),
              transportType: _unref(transportType),
              changeTransportType: _unref(changeTransportType),
              totalAmount: _unref(totalAmount),
              normalDisabled: _unref(cartGoodsMode) === 1 || _unref(isTikTokShop2C) || (_unref(sourceCountryRef) === _unref(COUNTRY).JP && _unref(isD2C)()),
              isTikTokShop2C: _unref(isTikTokShop2C),
              checkMap: _unref(checkMap)
            }, {
                        onRefresh: _cache[8] || (_cache[8] = async () => {
              await _unref(choiceFn).calcCheckPrice()
            }),
                        onCheckStatus: _cache[9] || (_cache[9] = e => checkShopCartStatus(4))
                      }), null, 16), [
                        [_directive_loading, _unref(requestNum) > 0]
                      ])
                    ], 512))
                  : _createCommentVNode("", true),
                (mode.value === 0 && _unref(isJA)() && _unref(isD2C)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
                  : _createCommentVNode("", true),
                (mode.value === 0 && _unref(isJA)() && _unref(isD2C)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('囤货仓库')), 1),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(stockWarehouse),
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(stockWarehouse) ? (stockWarehouse).value = $event : null))
                        }, {
                          prefix: _withCtx(() => [
                            _createElementVNode("div", _hoisted_32, [
                              (_unref(stockWarehouse) === 'CN')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_33))
                                : (_openBlock(), _createElementBlock("img", _hoisted_34))
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "CN",
                              label: _unref(cnWareName)
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_28, [
                                  _hoisted_29,
                                  _createElementVNode("span", null, _toDisplayString(_unref(cnWareName)), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              value: "JP",
                              label: _unref(t)('日本仓库')
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_30, [
                                  _hoisted_31,
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)('日本仓库')), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_unref(stockWarehouse) === 'JP')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(t)('注意：下单成功后，无法修改保管仓库，请谨慎选择')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(stockWarehouse) === 'JP')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, "日本倉庫納品先：〒373-0012 群馬県太田市清原町10-1 シャッターNo.6置配 "))
                        : _createCommentVNode("", true),
                      (_unref(cartIdList).length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_el_icon, { class: "icon" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(WarningFilled))
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('关于出口仓库选择的指引')) + ":", 1)
                              ]),
                              _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(t)('为确保您的商品顺利配送并符合出口申报政策，请根据出口模式合理选择仓库。')), 1),
                              _createElementVNode("div", {
                                class: "text",
                                innerHTML: _unref(t)('若选择中国仓（含杭州仓、广州仓、平湖仓），商品将通过个人直邮（D2C）模式出口，必须直接发往日本的最终消费者，不得转运至其他仓库。')
                              }, null, 8, _hoisted_41),
                              _hoisted_42,
                              _createElementVNode("div", {
                                class: "text",
                                innerHTML: _unref(t)('若选择日本仓，商品需先在中国仓完成质检，再由统一渠道转运至日本仓（B2B模式），最后由日本仓派送给最终消费者。')
                              }, null, 8, _hoisted_43),
                              _hoisted_44,
                              _createElementVNode("div", {
                                class: "text",
                                innerHTML: _unref(t)('请根据您的实际需求谨慎选择。如有任何疑问，请联系平台客服。')
                              }, null, 8, _hoisted_45)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(FigurePay, {
                  isExtStock: _unref(isExtStock),
                  pdtFee: pdtFee.value,
                  adtFee: adtFee.value,
                  curPdtFee: curPdtFee.value,
                  disabled: false,
                  onCommit: commit,
                  onCreateGroup: createGroup,
                  mode: mode.value,
                  isNumberExceed: _unref(isNumberExceed),
                  totalBuyQuantity: _unref(totalBuyQuantity),
                  showNum: true,
                  choiceTotalAmount: _unref(totalAmount),
                  isChoice: _unref(cartGoodsMode) === 2,
                  cartGoodsMode: _unref(cartGoodsMode),
                  ref: (_value, _refs) => {
                    _refs['figurePayRef'] = _value
                    figurePayRef.value = _value
                  },
                  isReady: isReady.value
                }, null, 8, ["isExtStock", "pdtFee", "adtFee", "curPdtFee", "mode", "isNumberExceed", "totalBuyQuantity", "choiceTotalAmount", "isChoice", "cartGoodsMode", "isReady"]),
                _createVNode(ConfirmOrder, _mergeProps({
                  modelValue: preview.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((preview).value = $event))
                }, {
            pdtFee: pdtFee.value,
            adtFee: adtFee.value,
            curPdtFee: curPdtFee.value,
            cartIdList: _unref(cartIdList),
            list: list.value,
            addressValid: addressValid.value,
            remainList: remainList.value,
            stockWarehouse: _unref(stockWarehouse),
            isTikTokShop2C: _unref(isTikTokShop2C),
            isTiktokWhite: isTiktokWhite.value,
            activityInfo: activityInfo.value
          }, {
                  layout: _unref(layout).slice(0, -1),
                  modeConfig: _unref(modes)[mode.value ? 0 : 1],
                  onSuccess: success,
                  onUpdate: update,
                  onClose: close,
                  modeValue: mode.value,
                  isUseOnTheWayStock: isUseOnTheWayStock.value,
                  checkList: _unref(checkList),
                  cartGoodsMode: _unref(cartGoodsMode)
                }), null, 16, ["modelValue", "layout", "modeConfig", "modeValue", "isUseOnTheWayStock", "checkList", "cartGoodsMode"]),
                _createVNode(ConfirmStockModal, {
                  ref: (_value, _refs) => {
                    _refs['confirmStockModal'] = _value
                    confirmStockModal.value = _value
                  },
                  onClose: confirmStockClose,
                  onSuccess: confirmStockSuccess,
                  checkList: _unref(checkList)
                }, null, 8, ["checkList"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 0,
            name: "b2b-shopcart"
          }))
        : _createCommentVNode("", true),
      (_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 1,
            name: "d2c-shopcart"
          }))
        : _createCommentVNode("", true),
      _createVNode(OpenMember, {
        ref: (_value, _refs) => {
          _refs['openMemberRef'] = _value
          openMemberRef.value = _value
        }
      }, null, 512),
      _createVNode(NoStockModal, {
        visible: noStockVisible.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((noStockVisible).value = $event)),
        goods: noStockGoods.value
      }, null, 8, ["visible", "goods"]),
      _createVNode(KrCustomsTip, {
        visible: isShowKrTip.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((isShowKrTip).value = $event)),
        onSuccess: customsCallback,
        type: 1
      }, null, 8, ["visible"]),
      _createVNode(NewUserTip),
      _createVNode(CartBcIntro),
      _createVNode(ChoiceConfirmOrder, {
        list: _unref(choiceFn).getChoiceCheckList(),
        modeConfig: _unref(modes)[mode.value ? 0 : 1],
        modeValue: mode.value,
        ref: (_value, _refs) => {
          _refs['choiceConfirmOrdeRef'] = _value
          choiceConfirmOrdeRef.value = _value
        },
        transportType: _unref(transportType),
        choiceTotalAmount: _unref(totalAmount),
        choiceFn: _unref(choiceFn),
        addressValid: addressValid.value,
        onSuccess: _cache[14] || (_cache[14] = ($event: any) => (_unref(choiceFn).getChoiceList()))
      }, null, 8, ["list", "modeConfig", "modeValue", "transportType", "choiceTotalAmount", "choiceFn", "addressValid"]),
      _createVNode(UnRechargeModal),
      _createVNode(FeeVipTip, {
        ref: (_value, _refs) => {
          _refs['feeVipTipRef'] = _value
          feeVipTipRef.value = _value
        },
        onCreateOrder: _cache[15] || (_cache[15] = ($event: any) => (commit(1)))
      }, null, 512)
    ])
  ], 64))
}
}

})